module.exports = __webpack_public_path__ + "img/40_69_003_570.c10fb471.jpg";